export { type ComplianceContainerProps, default } from './ComplianceContainer';
